import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/update-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-f6457faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "leftBox" }
const _hoisted_3 = { class: "appName" }
const _hoisted_4 = { class: "update" }
const _hoisted_5 = { class: "btnText" }
const _hoisted_6 = {
  key: 0,
  class: "updateTime"
}
const _hoisted_7 = {
  key: 0,
  class: "rightBox"
}

import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { dateFormat, dateFormatAm } from "@/utils/format";
import datePicker from "@/components/publicHeader/datePicker.vue";
import emitter from "@/utils/eventBus";
// let props = defineProps(['headerName', 'headerSyncDate'])
//这样写严谨一点

export default /*#__PURE__*/_defineComponent({
  __name: 'publicHeader',
  props: {
    headerName: {
        type: String,
    },
    headerSyncDate: {
        type: Number,
    },
    headerSelectData: {
        type: Array,
    },
    showUpdateTime: {
        type: Boolean,
        default: true
    },
    showRightBox: {
        type: Boolean,
        default: true
    },
    isSevenDay: {
        type: Boolean,
        default: false
    },
    isScreenTime: {
        type: Boolean,
        default: false
    }
},
  emits: ['updateHeaderDate', 'updateInfo'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const isVibe = computed(() => !store.state.isVibe);
// const isSevenDay = ref(false)//是否默认7天
const Emits = __emit
//同步loading
const syncLoading = computed(() => (store.state as any).headerStore.syncLoading)
const handleDateChange = (e: any, label: any) => {
    console.log("eeee:", e, label);
    Emits('updateHeaderDate', e, label)
}
//获取信息
const getInfo = () => {
    store.commit("setSyncLoading", true);
    Emits('updateInfo')
}
onMounted(() => {
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.headerName), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "rightContent",
          onClick: getInfo
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: _normalizeClass(["updateIcon", syncLoading.value ? 'loading' : '']),
            alt: ""
          }, null, 2),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("chat.sync")), 1)
        ]),
        (__props.showUpdateTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(dateFormat)(__props.headerSyncDate, "YYYY-MM-DD HH:mm")), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "headerInfo")
      ])
    ]),
    (__props.showRightBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(datePicker, {
            onChange: handleDateChange,
            syncLoading: syncLoading.value,
            isSevenDay: __props.isSevenDay,
            isScreenTime: __props.isScreenTime
          }, null, 8, ["syncLoading", "isSevenDay", "isScreenTime"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})